import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
import { NromalType } from '@/api/Login/type';

//获取培训计划配置
export const getTrainPlanConfigApi = (data: NromalType) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/getTrainPlanConfig', data);
};
// 查询培训类型列表
export const getTrainTypeApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/listTrainType', data);
};
// 查询培训类型配置
export const getTrainTypeConfigApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/getTrainTypeConfig', data);
};

// 查询培训计划模块
export const getTrainPlanModuleApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/teaching-item/module-list', data);
};
// 查询培训资源列表
export const getTrainPlanResourceListApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/tp/v1/listTrainRes', data);
};
// 查询培训计划整体完成情况
export const getTrainPlanCompleteInfoApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/getTrainComp', data);
};

// 查看培训计划心选内容
export const getHeartSelectDataApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/listHeartSelectData', data);
};
// 添加培训计划心选内容
export const addHeartSelectDataApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/tp/v1/addHeartSelectData', data);
};
// 删除培训计划心选内容
export const deleteHeartSelectDataApi = (id) => {
    return hMacAjax.delete(baseURL + '/grt-user-center-service/user/tp/v1/delHeartSelectData/'+id);
};
// 查询培训计划资源类型数据
export const getResourceTypeDataApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service//user/tp/v1/listTrainResType', data);
};
// 更多明细
export const getListTrainCompItemApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/tp/v1/listTrainCompItem', data);
};